import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cMsgDtl from './cMsgDtl';
import { View, Text, Keyboard } from 'react-native';

export default class iMsgDtl extends cMsgDtl {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

$id_stss = {
  sb_chk: false,
};

$ilp_upds = () => [ // 親を上書き
  new Promise( _o_end1 => { // 20211003 削除対応
    global.c?.state.sld_msgSubss
    .map( _d_items => {
//      if (_d_items.b_dlt == true) {
      if (_d_items.b_chk == true) {
        let _d_vals = {
          ct20cz10: '0',
        };
        let _cnd = bf.q(`[_KEY]={}`.f(_d_items.key));
        cf.myCB_call_iud({
          ctr: 'upd', 
          elm: 'ct20', 
          d_vals: _d_vals,
          cnd: _cnd,
        })
      }
    });
    _o_end1();
  }),
];

  render() {
    let _inpH = ic.gn_fontSizeNrm * 5 + ic.gn_mgnNrm * 2 + ic.gn_bdrWNrw * 1.5 * 2
    let _iniBtmH = ic.gn_fontSizeNrm * (2 + 1) + ic.gn_mgnNrm * 5 + ic.gn_bdrWNrw * 1.5 * 3;
    let _btmDh = ic.gn_fontSizeNrm * 4 + ic.gn_mgnNrm * 2 + ic.gn_bdrWNrw * 1.5 * 1;
//bf.l('48: {}'.f(global.c?.state.sgcd_kbds))
//bf.l('49: {}'.f(global.c?.state.sgcd_msrs))

/*
          b_rhtVsb={true}
          rhtIconName={
            (global.c?.state.sgc_pageMode == 'edit') ?
              'check'
            : 'trash'}
          rhtPfx={
            (global.c?.state.sgc_pageMode == 'edit') ?
              '反映'
            : '削除'}
          onRhtPrs={null}

              '選択'
              'check-square-o'
                global.c?.setState({
                  sb_chk: true,
                })
*/
    return (
      <this.$onChg>
        <ce.RootDtl
          key={-1}
          b_logo={false}
          onSchEnt={null}
          b_ste={true} 
          onBdyScrTop={()=>{
            global.c?._addMsgCnt(10);
          }}
          b_rhtVsb={true}
          rhtIconName={'check-square-o'}
          rhtPfx={'選択'}
          onRhtPrs={() => {
            global.c?.setState({
              sb_chk: true,
            });
          }}
          d_hdrs={{
            pfx: iv._get_hdrPfx('メッセージ情報'),
            d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgc_pageMode),
            d_subMenus: {
              b_vsb: true,
              iconName: 'gear',
              pfx: '設定',
              o_onPrs: () => {
                let _d_pageInfs = {
                  sgc_pageRole: global.c?.state.sgc_pageRole,
                  sgc_pageName: 'iMsgSet',
                  sgc_pageMode: 'show',
                  sgc_pagePrc: '',
                };
                cf.myRN_move_fwd(_d_pageInfs);
              },
            },
          }}
          lo_hdrs={
            (global.c?.state.sb_chk) ? 
              [
                ce.c(ce.BtnIconPfx, {
                  key: -1,
                  iconName: 'remove',
                  pfx: 'キャンセル',
                  ccd: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                  onPrs: () => {
                    global.c?.setState({
                      sb_chk: false,
                      sld_msgSubss: bf.p(global.c?.state.sld_msgSubss, _next => {
                        _next.map( _d_msgs => {
                          if (_d_msgs.b_chk) _d_msgs.b_chk = false;
                        })
                      }),
                    });
                  },
                  stlCta: {
                    height: ic.gn_btnIconSize + ic.gn_fontSizeSml,
                  },
                }),
              ]
            : null
          }
          lo_ftrs={
            (global.c?.state.sb_chk) ? 
              [
                ce.c(ce.BtnIconPfx, {
                  key: -1,
                  iconName: 'trash',
                  pfx: '削除',
                  ccd: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd,
                  onPrs: () => {
                    let _n_cnt = global.c?.state.sld_msgSubss.reduce( (_prev, _d_msgs) => {
                      return (_d_msgs.b_chk) ? (_prev + 1) : _prev
                    }, 0)
                    if (_n_cnt == 0) {
                      alert('項目を選択ください')
                    }
                    else {
                      global.c?.setState({
                        sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                          _next.cfm.b_showMdl = true;
                          _next.cfm.msg = '選択項目を削除してよろしいですか？';
                          _next.cfm.ld_btnss = [
                            {
                              pfx:'はい',
                              o_onPrs: async () => {
                                global.c?.upd();
                              },
                            },
                            {
                              pfx:'いいえ',
                            },
                          ];
                        }),
                      });
                    }
                  },
                }),
              ]
            : null
          }
          d_bdys={{
            ld_defss: [
              {
                type: 'ListChat',
                b_vsb: true,
                b_edt: (global.c?.state.sgc_pageMode == 'edit') ? true : false,
                state: 'sld_msgSubss',
                b_chb: false,
                b_prs: false,
                b_avt: false,
                b_chk: global.c?.state.sb_chk,
                ob_chk: _d_is => {
//bf.l('187: {}, {}'.f(_d_is.vals.ct20cy20, global.c?.state.sgcd_pagePntKeys))
                  return (_d_is.vals.ct20cy20 == global.c?.state.sgcd_pagePntKeys?.cm10_key) ? true : false;
                }
              },
            ],
          }}
          d_btms={{
/*
            n_h: cf.myRN_chk_os('w') ?
                _btmDh + _iniBtmH
              : (global.c?.state.sgcn_btmDh ?? 0) + _iniBtmH,
*/
            n_h:
              (global.c?.state.sb_chk) ?
                0 
              : cf.myRN_chk_os('w') ?
                _btmDh + _iniBtmH
              : (global.c?.state.sgcn_btmDh ?? 0) + _iniBtmH,
            ld_defss: [
              {
                type: 'Btns',
                b_vsb: true,
                stlCta: {
                  marginTop: ic.gn_mgnNrm,
                },
                ld_defss: [
                  {
//                    b_rvs: false,
                    b_rvs: (global.c?.state.sb_chk != true) ? false : true,
                    pfx: 'ファイル添付',
                    onPrs: 
                      (global.c?.state.sb_chk != true) ?
                        ()=>{
                          global.c?.setState({
                            sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                              _next.pckFiles.b_showMdl = true;
                            }),
                          });
                        }
                      : null,
                    stlBtn: {
                      width: ic.gn_btnWLrg,
                    }
                  },
                  {
                    b_rvs: (global.c?.state.sb_chk != true) ? false : true,
                    pfx: '送る',
                    onPrs: 
                      (global.c?.state.sb_chk != true) ?
                        ()=>{
                          if (global.c?.state.s_newMsg != '') {
                            let _d_vals = {
                              ct20b11k: global.c?.state.sgcd_pagePntKeys.ct21_key, // お客様 am1d_key
                              ct20c110: '', // 送信番号
                              ct20c410: '10', // 送信区分
                              ct20c610: global.c?.state.s_newMsg, // 送信内容
                              ct20cy10: bf.myDT_get_now(),
                              ct20cy20: global.c?.state.sgcd_pagePntKeys.cm10_key, // 送信者 am1d_key
                              ct20cz10: '10',
                            }
                            cf.myCB_call_iud({
                              ctr: 'ins', 
                              elm: 'ct20', 
                              d_vals: _d_vals
                            })
                            .then((_d_ct20s)=>{
    //                          this.load(true, 1); // 追加分を表示
                              Keyboard.dismiss();
                              global.c?.load()
                              .then(() => {
                                global.c?._addMsgCnt(1)
                                .then(() => {
                                  global.c?.setState({
                                    s_newMsg:'',
                                      sgcn_btmDh: 0,
                                  });
                                });
                              }); // 追加分を表示
                            });
                          };
                        }
                    : null,
                    stlBtn: {
                      width: ic.gn_btnWLrg,
                    }
                  },
                ], 
              },
              {
                type: 'Inp',
                b_vsb: true,
                b_edt: (global.c?.state.sb_chk != true) ? true : false,
                state: 's_newMsg',
                phd: 'メッセージを入力ください',
                b_mln: true,
                b_flg: true,
//                n_maxCnt: 400,
                onFcs: () => {
                  global.c?.setState({
                    sgcn_btmDh: _btmDh,
                  })
                },
                onBlur: () => {
                  global.c?.setState({
//                    sgcn_btmH: _minBtmH,
                    sgcn_btmDh: 0,
                  })
                },
                stlInp: {
                  height: _inpH,
                },
              },
            ]
          }}
        />
        <ce.PckFilesMdl
          key={-2}
          state='sld_filess'
          onPrs={async ()=>{
            //
//            cf.myRN_ldr_show(global.c); // ldr の表示
            cf.myRN_ldr_show(); // ldr の表示
            //
/*
            // 幹となるメッセージの追加
            bf.myCM_for_each(global.c?.state.sld_filess, (_d_files)=>{
              let _d_vals = {
                ct20b11k: global.c?.state.sgcd_pagePntKeys.ct21_key, // お客様 am1d_key
                ct20cy20: global.c?.state.sgcd_pagePntKeys.cm10_key, // 送信者 am1d_key
                ct20012p: global.c?.state.sgcd_pagePntKeys.cm10c310, // 送信者名
                ct20c110: '', // 送信番号
                ct20c410: '20', // 送信区分：ファイル
                ct20c610: _d_files.name, // 送信内容
                ct20cy10: bf.myDT_get_now(),
              }
              cf.myCB_call_iud({
                ctr: 'ins', 
                elm: 'ct20', 
                d_vals: _d_vals
              })
              .then((_d_ct20s)=>{
                cp.$cp_hlr_ct10({
                  mode: 'upd',
                  elm: 'ct21', // upl, slc 
                  key: global.c?.state.sgcd_pagePntKeys.ct21_key, // upl, slc
                  state: 'sld_files', // upl, slc
                })

              });
            })
            .then(()=>{
              global.c?.load()
              .then(() => { // 追加分を表示
                global.c?._addMsgCnt(1)
                .then(() => {
                  global.c?.setState({
                    sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                      _next.pckFiles.b_showMdl = false;
                    }),
                  }, () => {
//                    cf.myRN_ldr_hide(global.c); // ldr の非表示
                    cf.myRN_ldr_hide(); // ldr の非表示
                  });
                }); 
              });
              //
              if (global.c?.state.sgc_cm10_key != global.c?.state.sgcd_pagePntKeys.cm10_key) { // お客さまが送信者でない場合
                cf.myCB_call_slc({
                  ctr: 'nlm',
                  elm: 'am1d', 
                  n_dms: 2, 
                  cnd: bf.q('[_KEY]={}'.f(global.c?.state.sgcd_pagePntKeys.cm10_key))
                })
                .then((_d_am1ds) => {
                  cf.myCB_call_eml(_d_am1ds.am1d1030, '新規メッセージのお知らせ', '{}さんが、新規にメッセージを登録しました'.f(global.c?.state.sgc_user_pfx))
                });
              };
            });
*/
//bf.l('204:{}'.f(global.c?.state.sgcd_pagePntKeys))
            await Promise.all(global.c?.state.sld_filess.map( async (_d_files, _idx) => {
              let _d_vals = {
                ct20b11k: global.c?.state.sgcd_pagePntKeys.ct21_key, // お客様 am1d_key
                ct20c110: '', // 送信番号
                ct20c410: '20', // 送信区分：ファイル
                ct20c610: _d_files.name, // 送信内容
                ct20cy10: bf.myDT_get_now(),
                ct20cy20: global.c?.state.sgcd_pagePntKeys.cm10_key, // 送信者 am1d_key
                ct20cz10: '10',
              }
//bf.l('215:{}'.f(_d_vals))
              await cf.myCB_call_iud({
                ctr: 'ins', 
                elm: 'ct20', 
                d_vals: _d_vals
              })
              .then( async (_d_ct20s)=>{
//bf.l('222:{}'.f(_d_ct20s))
                await cp.$cp_hlr_ct10({
                  mode: 'upd',
                  elm: 'ct20', // upl, slc 
//                  key: global.c?.state.sgcd_pagePntKeys.ct21_key, // upl, slc
                  key: _d_ct20s._KEY, // upl, slc
                  state: 'sld_filess', // upl, slc
                })
              });
            }))
            .then(() => {
//bf.l('230:here')
              global.c?.load()
              .then(() => { // 追加分を表示
//bf.l('234:here')
                global.c?._addMsgCnt(1)
                .then(() => {
//bf.l('237:here')
                  global.c?.setState({
                    sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                      _next.pckFiles.b_showMdl = false;
                    }),
                  }, () => {
//bf.l('240:here')
                    cf.myRN_ldr_hide(); // ldr の非表示
                  });
                }); 
              });
            });
          }}
        />
      </this.$onChg>
    );
  }

};
